export const getFirstDataString = (data) => {
  const dataDecimalPart = data?.split(/ (.*)/)[0];
  return dataDecimalPart.length > 3
    ? `${dataDecimalPart.slice(0, dataDecimalPart.length - 3)},${dataDecimalPart.slice(dataDecimalPart.length - 3, dataDecimalPart.length)}`
    : dataDecimalPart;
};

export const getSecondDataString = (data) => data?.split(/ (.*)/)[1];
